import {
  JourneyAttribute,
  JourneyAttributeCatalog,
  JourneyAttributeCatalogKey,
} from '@hc-frontend/services';
import { assoc, reduce } from 'ramda';

export function journeyAttributesMapper(journeyAttributes: JourneyAttribute[]) {
  const journeyAttributesMap: Partial<{
    [key in JourneyAttributeCatalogKey]: JourneyAttributeCatalog[key];
  }> = {
    ...reduce(
      (acc, curr) => assoc(curr.name, curr.value, acc),
      {},
      journeyAttributes,
    ),
  };
  return journeyAttributesMap;
}
